<template>
  <div class="data-page common-bg">
    <!-- 日期选项卡 -->
    <div class="date-tabs-custom">
      <div class="date-tab" v-for="(item, index) in dateTabs" :key="index" :class="{ active: activeDateTab === index }" @click="activeDateTab = index">
        {{ item }}
      </div>
    </div>

    <!-- 今日佣金 -->
    <div class="today-commission">
      <div class="commission-header">
        <span class="commission-label">{{ currentCommissionLabel }}</span>
        <div class="commission-right">
          <span class="commission-amount">{{ todayCommission }}</span>
          <span class="commission-total">(总佣金 {{ totalCommission }})</span>
        </div>
      </div>
      <div class="commission-categories">
        <div class="category-item" v-for="(item, index) in commissionCategories" :key="index">
          <div class="category-name">{{ item.name }}</div>
          <div class="category-value">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <!-- 全部数据 -->
    <div class="data-section">
      <div class="section-title">全部数据</div>
      <div class="data-grid">
        <div class="data-card" v-for="(item, index) in dataCards" :key="index">
          <div class="card-title">
            <span class="title-main">{{ item.title.split('(')[0] }}</span>
            <span class="title-sub" v-if="item.title.includes('(')">({{ item.title.split('(')[1].replace(')', '') }})</span>
          </div>
          <div class="card-value">
            <span class="value-main">{{ item.value.split('(')[0] }}</span>
            <span class="value-sub" v-if="item.value.includes('(')">({{ item.value.split('(')[1].replace(')', '') }})</span>
          </div>
          <div class="card-detail" v-if="item.direct !== undefined">
            <div class="detail-row">
              <span class="detail-label">直属数据</span>
              <span class="detail-value">
                <span class="value-main">{{ String(item.direct).split('(')[0] }}</span>
                <span class="value-sub" v-if="String(item.direct).includes('(')">({{ String(item.direct).split('(')[1].replace(')', '') }})</span>
              </span>
            </div>
            <div class="detail-row">
              <span class="detail-label">其他数据</span>
              <span class="detail-value">
                <span class="value-main">{{ String(item.other).split('(')[0] }}</span>
                <span class="value-sub" v-if="String(item.other).includes('(')">({{ String(item.other).split('(')[1].replace(')', '') }})</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 累计数据 -->
    <div class="data-section">
      <div class="section-title">累计数据(含其他下级)</div>
      <div class="accumulate-grid">
        <div class="accumulate-card" v-for="(item, index) in accumulateCards" :key="index">
          <div class="accumulate-title">{{ item.title }}</div>
          <div class="accumulate-value" :class="{ gold: item.gold }">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <!-- 我的累计收益 -->
    <div class="data-section">
      <div class="section-title">我的累计收益</div>
      <div class="income-grid">
        <div class="income-card" v-for="(item, index) in incomeCards" :key="index">
          <div class="income-title">{{ item.title }}</div>
          <div class="income-value">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'promoteData',
  data() {
    return {
      activeDateTab: 0,
      dateTabs: ['今日', '昨日', '本周', '上周', '本月', '上月'],
      todayCommission: '0.00',
      totalCommission: '0.00',
      commissionCategories: [
        { name: '直属佣金', value: '0.00' },
        { name: '其他佣金', value: '0.00' },
        { name: '推广活动奖励', value: '0.00' },
        { name: '代理活动奖励', value: '0.00' },
      ],
      dataCards: [
        { title: '总新增人数', value: '1', direct: '1', other: '0' },
        { title: '总充值(人次)', value: '0.00', direct: '0.00(0)', other: '0.00(0)' },
        { title: '总首充(人数)', value: '0.00(0)', direct: '0.00(0)', other: '0.00(0)' },
        { title: '当天注册首充(人数)', value: '0.00(0)', direct: '0.00(0)', other: '0.00(0)' },
        { title: '总提现(次数)', value: '0.00(0)', direct: '0.00(0)', other: '0.00(0)' },
        { title: '领取总奖励(人次)', value: '0.00(0)', direct: '0.00(0)', other: '0.00(0)' },
        { title: '总有效投注(人次)', value: '0.00(0)', direct: '0.00(0)', other: '0.00(0)' },
        { title: '总业绩(人次)', value: '0.00(0)', direct: '0.00(0)', other: '0.00(0)' },
        { title: '总输赢(人次)', value: '0.00(0)', direct: '0.00(0)', other: '0.00(0)' },
      ],
      accumulateCards: [
        { title: '总人数', value: '1', gold: false },
        { title: '直属人数', value: '1', gold: true },
        { title: '其他人数', value: '0', gold: false },
        { title: '总业绩', value: '0.00', gold: false },
        { title: '直属业绩', value: '0.00', gold: false },
        { title: '其他业绩', value: '0.00', gold: false },
        { title: '累计直属充值', value: '0.00', gold: false },
        { title: '累计直属提现', value: '0.00', gold: false },
        { title: '累计直属领取', value: '0.00', gold: false },
        { title: '累计直属有效投注', value: '0.00', gold: false },
        { title: '累计直属输赢', value: '0.00', gold: false },
      ],
      incomeCards: [
        { title: '总佣金', value: '0.00' },
        { title: '直属佣金', value: '0.00' },
        { title: '其他佣金', value: '0.00' },
        { title: '累计实发佣金', value: '0.00' },
        { title: '待领取', value: '0.00' },
        { title: '已领取', value: '0.00' },
        { title: '推广活动累计奖励', value: '0.00' },
        { title: '代理活动累计奖励', value: '0.00' },
      ],
    };
  },
  computed: {
    currentCommissionLabel() {
      const labels = ['今日佣金', '昨日佣金', '本周佣金', '上周佣金', '本月佣金', '上月佣金'];
      return labels[this.activeDateTab] || '今日佣金';
    },
  },
  created() {
    this.loadData();
  },
  watch: {
    activeDateTab() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      let that = this;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../static/css/common.css';

.data-page {
  min-height: 100vh;
  padding: 0.2rem;
  padding-bottom: 0.5rem;
  background: #1E1F24;
  box-sizing: border-box;
}

.date-tabs-custom {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.2rem;

  .date-tab {
    flex: 1;
    text-align: center;
    padding: 0.12rem 0;
    margin: 0 0.06rem;
    border-radius: 0.3rem;
    font-size: 0.3rem;
    color: #888;
    background: #292A2C;
    border: 1px solid #3B3C3D;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    &.active {
      color: #333;
      background: #DFB372;
      border-color: #DFB372;
      font-weight: 500;
    }
  }
}

.today-commission {
  background: #292A2C;
  border-radius: 0.16rem;
  padding: 0.25rem 0.2rem;
  margin-bottom: 0.2rem;

  .commission-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 0.25rem;

    .commission-label {
      font-size: 0.3rem;
      color: #fff;
    }

    .commission-right {
      display: flex;
      align-items: baseline;

      .commission-amount {
        font-size: 0.35rem;
        font-weight: bold;
        color: #DFB372;
        margin-right: 0.1rem;
      }

      .commission-total {
        font-size: 0.3rem;
        color: #666;
      }
    }
  }

  .commission-categories {
    display: flex;

    .category-item {
      flex: 1;
      text-align: center;

      .category-name {
        font-size: 0.3rem;
        color: #888;
        margin-bottom: 0.08rem;
      }

      .category-value {
        font-size: 0.35rem;
        color: #DFB372;
        font-weight: bold;
      }
    }
  }
}

.data-section {
  margin-bottom: 0.25rem;

  .section-title {
    font-size: 0.35rem;
    color: #fff;
    text-align: center;
    font-weight: 500;
    margin-bottom: 0.2rem;
  }
}

.data-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.12rem;

  .data-card {
    width: calc(50% - 0.06rem);
    background: #292A2C;
    border-radius: 0.12rem;
    padding: 0.22rem;
    box-sizing: border-box;

    .card-title {
      font-size: 0.3rem;
      margin-bottom: 0.1rem;

      .title-main {
        color: #fff;
      }

      .title-sub {
        color: #888;
      }
    }

    .card-value {
      font-size: 0.35rem;
      font-weight: bold;
      margin-bottom: 0.12rem;

      .value-main {
        color: #fff;
      }

      .value-sub {
        color: #666;
        font-weight: normal;
      }

      .gold {
        color: #DFB372;
      }
    }

    .card-detail {
      .detail-row {
        display: flex;
        justify-content: space-between;
        font-size: 0.3rem;
        margin-bottom: 0.04rem;

        &:last-child {
          margin-bottom: 0;
        }

        .detail-label {
          color: #666;
        }

        .detail-value {
          .value-main {
            color: #fff;
          }

          .value-sub {
            color: #666;
          }
          &.gold {
            color: #DFB372;
          }
        }
      }
    }
  }
}

.accumulate-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.12rem;

  .accumulate-card {
    width: calc(33.333% - 0.08rem);
    background: #292A2C;
    border-radius: 0.12rem;
    padding: 0.2rem 0.15rem;
    box-sizing: border-box;
    text-align: center;

    .accumulate-title {
      font-size: 0.3rem;
      color: #fff;
      margin-bottom: 0.1rem;
      line-height: 1.2;
    }

    .accumulate-value {
      font-size: 0.35rem;
      color: #fff;
      font-weight: bold;

      &.gold {
        color: #DFB372;
      }
    }
  }
}

.income-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.12rem;

  .income-card {
    width: calc(33.333% - 0.08rem);
    background: #2A2618;
    border: 1px solid #3B3518;
    border-radius: 0.12rem;
    padding: 0.2rem 0.15rem;
    box-sizing: border-box;
    text-align: center;

    .income-title {
      font-size: 0.3rem;
      color: #fff;
      margin-bottom: 0.1rem;
      line-height: 1.2;
    }

    .income-value {
      font-size: 0.35rem;
      color: #DFB372;
      font-weight: bold;
    }

    &:nth-last-child(-n+2) {
      .income-value {
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/component/promote/Data.vue